import {
    ACCOUNT_DETAIL_RESET_TO_DEAFULT
} from './actionTypes';

export function resetToDefault() {
    return {
        type: ACCOUNT_DETAIL_RESET_TO_DEAFULT
    }
}